export const config = {
  /****** COMMENT TIMING ******/
  commentActionWindowDuration: +(process.env.REACT_APP_COMMENT_ACTION_WINDOW || 30),
  commentActionWindowDurationNonAdmin: +(process.env.REACT_APP_COMMENT_ACTION_WINDOW_NON_ADMIN || 10),
  commentActionWindowUnit: process.env.REACT_APP_COMMENT_ACTION_WINDOW_UNIT || 'minutes',

  /****** LOGOUT POPUP ******/
  minutesUntilLogoutPopup: parseFloat(process.env.REACT_APP_MINUTES_UNITL_POPUP || '29'),
  minutesUntilAutoLogout: parseFloat(process.env.REACT_APP_MINUTES_UNITL_AUTO_LOGOUT || '30'),

  /****** CIL-NOTIFICATIONS **********/
  cilApiBaseURI: process.env.REACT_APP_CIL_API_BASE_URI || 'https://www.fnhw.com',
  cilApiUserName: process.env.REACT_APP_CIL_API_USERNAME || '1magineX_Dev',
  cilApiPassword: process.env.REACT_APP_CIL_API_PASSWORD || '1magineX_Dev',

  /****** GENERAL CONFIG ******/
  host: process.env.REACT_APP_HOST || window.location.origin || 'http://localhost:3000',
  apiHost: process.env.REACT_APP_API_HOST || `${window.location.origin}/api` || 'http://localhost:3000/api',
  environment: process.env.REACT_APP_ENV || 'Local',

  version: process.env.REACT_APP_VERSION || '0.0',
  bucketUrl:
    'https://s3-us-west-2.amazonaws.com/bugs2-public-' +
    (process.env.REACT_APP_ENV === 'Production' ? 'prod' : process.env.REACT_APP_ENV === 'Staging' ? 'qa' : 'dev'),
  tutorialURL: 'https://s3-us-west-2.amazonaws.com/wise-training-content/',
  /******** HOSTED CHECKOUT *********/
  hostedCheckoutPostEndpoint:
    process.env.REACT_APP_HOSTED_CHECKOUT_POST_URI || 'https://demo.globalgatewaye4.firstdata.com/payment'
};



// WEBPACK FOOTER //
// ./src/common/config.ts